import React from 'react';
import { Field, inputClasses } from './Field';
interface CurrencyFieldProps {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
  required?: boolean;
  error?: string;
  hint?: string;
  readOnly?: boolean;
  emphasis?: boolean;
  className?: string;
}
export function CurrencyField({
  id,
  label,
  value,
  onChange,
  onBlur,
  required,
  error,
  hint,
  readOnly,
  emphasis,
  className
}: CurrencyFieldProps) {
  return <Field id={id} label={label} required={required} error={error} hint={hint} className={className} data-id="element-69" data-mp="30j37sva3ry6z">
      <div className="relative" data-id="element-70" data-mp="2lkrft1xoddm5">
        <span aria-hidden="true" className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-sm text-ink-400" data-id="element-71" data-mp="2qkdnywync3o3">
          $
        </span>
        <input id={id} name={id} type="text" inputMode="decimal" autoComplete="off" value={value} readOnly={readOnly} placeholder="0.00" aria-required={required} aria-invalid={Boolean(error)} aria-describedby={error ? `${id}-error` : hint ? `${id}-hint` : undefined} onChange={e => onChange(e.target.value)} onBlur={onBlur} className={inputClasses(Boolean(error), `numeric pl-7 pr-3 text-right ${emphasis ? 'font-semibold text-ink-900' : ''} ${readOnly ? 'cursor-default bg-ink-50 text-ink-600' : ''}`)} data-id="element-72" data-mp="1a88c396dcm95" />
      </div>
    </Field>;
}